import Vue from 'vue'

const PERCENT_LOAD_LIST = 60 // The time that will handle loading for list of data

var store = {
	currentModals: [],
	clickDropdown,
	autoCloseDropdown,
	openModal,
	hideModal,
	canLoadingData,
	validateEmail,
	checkNumber,
	checkNull,
	isMobile: (navigator.userAgent.indexOf('iPhone') > 0) || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0),
	fixedHeader: {
		isWindowInit,
		isFixheader,
		syncXScroll
	}
}

Vue.use({
	install(Vue, options) {
		Vue.prototype['$self'] = store
	}
})

var menulist = [
	'.category',
	'.job',
	'.employees',
	'.filter-sort',
	'.share-button'
];

function autoCloseDropdown() {
	$(document).on('click', function (e) {
		if ($(e.target).closest('.category > .dropdown-button').length) {
			closemenu($('.category'));
		} else if ($(e.target).closest('.job > .dropdown-button').length) {
			closemenu($('.job'));
		} else if ($(e.target).closest('.employees > .dropdown-button').length) {
			closemenu($('.employees'));
		} else if ($(e.target).closest('.filter-sort > .dropdown-button').length) {
			closemenu($('.filter-sort'));
		} else if ($(e.target).closest('.share-button > .dropdown-button').length) {
			closemenu($('.share-button'));
		} else {
			closeall()
		}
	});
}

function clickDropdown() {
	var element = $('.dropdown > .dropdown-button');
	if (!element.hasClass('is-hidden')) {
		if (element.next().is(':hidden')) {
			element.next().slideDown(200);
			closemenu(element.parent());
		} else {
			element.next().slideUp(200);
		}
	}
}

//特定のメニュー以外を閉じる
function closemenu(obj, isAll = false) {
	var objstr = '.' + obj.attr('class').split(' ')[0];
	for (var i = 0; i < menulist.length; i++) {
		if (objstr != menulist[i]) {
			$((menulist[i] + ' > ul')).slideUp(200);
		}
	}
}

//すべてのメニューを閉じる
function closeall() {
	for (var i = 0; i < menulist.length; i++) {
		$((menulist[i] + ' > ul')).slideUp(200);
	}
}

// Open Modal
function openModal(element, isNotClose = false) {
	var $modalWin = $(element)
	var $shadeWin = $('.shade')
	var $window = $(window)
	var posX = ($window.width() - $modalWin.outerWidth()) / 2
	var posY = ($window.height() - $modalWin.outerHeight()) / 2
	$modalWin.css({ left: posX, top: posY })
	$modalWin.fadeIn(200)
	$shadeWin.fadeIn(200)
	store.currentModals.push({
		'name': element,
		'isNotClose': isNotClose
	})
	$('body').addClass('no-scroll');
}

// Hide Modal
function hideModal(element, time = 100) {
	if (element) {
		// remove in list of currentModals
		for (var i = store.currentModals.length - 1; i >= 0; i--) {
			if (store.currentModals[i].name === element) {
				store.currentModals.splice(i, 1)
			}
		}
		if (store.currentModals.length === 0) {
			$('.shade').fadeOut(time)
			$('body').removeClass('no-scroll');
			$('.container').off('.noScroll');
		}
		$(element).fadeOut(time)
	}
	else {
		store.currentModals = []
		$('.shade').fadeOut(time)
		$('.popup').fadeOut(time)
		$('body').removeClass('no-scroll');
		$('.container').off('.noScroll');
	}
}

// Check for loading list of data
function canLoadingData(x = window, y = document, percentLoadList = PERCENT_LOAD_LIST) {
	return $(x).scrollTop() * 100 / ($(y).height() - $(x).height()) > percentLoadList
}

// Check validate of email
function validateEmail(email) {
	var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regExp.test(String(email))
}

// Check is an integer and not a 2 byte number
function checkNumber(num) {
	if (isNaN(num) || num < 0 || (num && (num.toString().indexOf('.') != -1 || num.toString().indexOf('e') != -1 || num.toString().indexOf(' ') != -1)))
		return false
	return true
}

// Null or Empty check
function checkNull(str){
	if (str == null || str == "") {
		return true;
	} else {
		return false;
	}
}

/**
 * fixed_header
 */

// 縮小した時のヘッダーの高さ
var fixheader_height = 64;
var header_pos = 0;
var subheader_map = [];
var xpos = 0;
var table_height = 0;

// リサイズイベントで要素の位置を取得する
function isWindowInit() {
	if (document.getElementById('progress-content')) {
		var pageY = window.pageYOffset;
		subheader_map = []
		header_pos = document.getElementById('header').getBoundingClientRect().top + pageY;
		table_height = $('#progress-content').height();
		var subheaders = document.getElementsByClassName('table-header');
		for (var idx = 0; idx < subheaders.length; idx++) {
			var elem = subheaders[idx];
			var elem_id = elem.id;
			var el_top = elem.getBoundingClientRect().top + pageY;
			subheader_map.push({
				elem_id: elem_id,
				top: el_top,
			});
		}
		// 画面下から順にソート
		subheader_map.sort(function (a, b) {
			return (a.top < b.top) ? 1 : (a.top > b.top) ? -1 : 0;
		});
	}
}

// スクロールイベントで属性値を変更
function isFixheader() {
	if (document.getElementById('progress-content')) {
		table_height = $('#progress-content').height();
		var sc = window.pageYOffset;
		if (sc > header_pos) {
			document.getElementById('header').setAttribute('data-fixed', '1');
		} else {
			document.getElementById('header').setAttribute('data-fixed', '0');
		}
		var f = false;
		for (var idx in subheader_map) {
			if (sc > subheader_map[idx].top - fixheader_height && sc < subheader_map[idx].top + table_height - fixheader_height - 40 && !f) {
				document.getElementById(subheader_map[idx].elem_id).setAttribute('data-fixed', '1');
				$('#home__progress__content').css('padding-top', '40px');
				f = true;

			} else {
				document.getElementById(subheader_map[idx].elem_id).setAttribute('data-fixed', '0');
				$('#home__progress__content').css('padding-top', '0px');
			}
		}
	}
}

function syncXScroll() {
	if (document.getElementById('progress-content')) {
		var table = document.getElementById('progress-content');
		var table_header = document.getElementById('home__progress__header');
		var table_content = document.getElementById('home__progress__content');
		xpos = table.scrollLeft;
		$('#home__progress__header').css('left', (-1 * xpos));
	}
}

if (store.isMobile) {
	window.addEventListener('resize', isWindowInit, false);

	$(window).scroll(function () {
		isFixheader();
	})
}

export default store


// WEBPACK FOOTER //
// ./src/services/store.js